const SvgStar = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 17 16">
    <path fill="#373737" d="m4.634 14.667 1.083-4.684-3.633-3.15 4.8-.416L8.75 2l1.867 4.417 4.8.416-3.633 3.15 1.083 4.684-4.117-2.484z" />
  </svg>;
export default SvgStar;